const AUTH_ACCESS_TOKEN_KEY = "accessToken";
const AUTH_USER_DATA_KEY = "userData";
const AUTH_USER_ROLE_KEY = "userRole";
const AUTH_EMAIL_KEY = "Email";

export const USER_ROLE = {
  DRIVER: "driver",
  RIDER: "rider",
};

function isDriverProfile(profile) {
  if (!profile || typeof profile !== "object") {
    return false;
  }
  return Boolean(profile.driverEmail || profile.licenceDetails);
}

export function normalizeUserData(stored) {
  if (!stored || typeof stored !== "object") {
    return null;
  }
  if (stored.role && stored.userId) {
    return stored;
  }
  if (stored.data && typeof stored.data === "object") {
    const profile = stored.data;
    const role = isDriverProfile(profile) ? USER_ROLE.DRIVER : USER_ROLE.RIDER;
    return {
      role,
      userId: profile._id,
      displayName: profile.fullName || profile.driverEmail || profile.email,
      email: profile.driverEmail || profile.email,
      profile,
    };
  }
  if (stored.driverEmail) {
    return {
      role: USER_ROLE.DRIVER,
      userId: stored._id,
      displayName: stored.fullName || stored.driverEmail,
      email: stored.driverEmail,
      profile: stored,
    };
  }
  if (stored._id) {
    return {
      role: USER_ROLE.RIDER,
      userId: stored._id,
      displayName: stored.fullName || stored.email,
      email: stored.email,
      profile: stored,
    };
  }
  return null;
}

export function parseStoredSession() {
  const accessToken = localStorage.getItem(AUTH_ACCESS_TOKEN_KEY);
  const rawUserData = localStorage.getItem(AUTH_USER_DATA_KEY);
  if (!rawUserData) {
    return { accessToken, session: null };
  }
  try {
    const parsed = JSON.parse(rawUserData);
    const session = normalizeUserData(parsed);
    return { accessToken, session };
  } catch {
    return { accessToken, session: null };
  }
}

export function saveAuthSession(session, accessToken) {
  if (accessToken) {
    localStorage.setItem(AUTH_ACCESS_TOKEN_KEY, accessToken);
  }
  localStorage.setItem(AUTH_USER_DATA_KEY, JSON.stringify(session));
  localStorage.setItem(AUTH_USER_ROLE_KEY, session.role);
}

export function buildSessionFromLoginPayload(loginPayload, role) {
  if (role === USER_ROLE.DRIVER) {
    return normalizeUserData(loginPayload);
  }
  const profile = loginPayload.data || loginPayload;
  return {
    role: USER_ROLE.RIDER,
    userId: profile._id,
    displayName: profile.fullName || profile.email,
    email: profile.email,
    profile,
  };
}

export function extractAccessToken(loginPayload) {
  return (
    loginPayload.accessToken ||
    loginPayload.access_token ||
    loginPayload.token ||
    null
  );
}

export function clearAuthSession() {
  localStorage.removeItem(AUTH_ACCESS_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_DATA_KEY);
  localStorage.removeItem(AUTH_USER_ROLE_KEY);
  localStorage.removeItem(AUTH_EMAIL_KEY);
}

export function getDriverOnboardingPath(profile) {
  if (!profile) {
    return "/personaldocument";
  }
  const licenceDetails = profile.licenceDetails || [];
  const vehicleRegistrationDetails = profile.vehicleRegistrationDetails || [];
  if (licenceDetails.length === 0) {
    return "/personaldocument";
  }
  if (vehicleRegistrationDetails.length === 0) {
    return "/cardocument";
  }
  return "/personaldocument";
}

export function getDriverIdFromSession(session) {
  if (!session || session.role !== USER_ROLE.DRIVER) {
    return null;
  }
  return session.userId;
}
